import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { SwModalframeComponent } from 'src/app/librarys/components/basic-components/sw-modal-frame/sw-modal-frame.component';
import { SwGridTableComponent } from 'src/app/librarys/components/basic-components/sw-table/sw-grid-table/sw-grid-table.component';
import { SwJwtService } from 'src/app/librarys/serves/sw-jwt.service';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { environment } from 'src/environments/environment';
import { KmsService } from '../../../../kms.service';
import { KmsEnum } from '../../../../serves/kms-enum';
import { InstanceModuleService } from 'src/app/areas/kms/serves/instance/instance.module';
declare var $;
@Component({
  selector: 'app-related-resource-select',
  templateUrl: './related-resource-select.component.html',
  styleUrls: ['./related-resource-select.component.css']
})
export class RelatedResourceSelectComponent implements OnInit {
  @ViewChild('modal') modal: SwModalframeComponent;    //弹出层组件
  @Input() param:any;
  @Output() callback = new EventEmitter(); //抛出事件
  // 当前选中的tabid
  currentTab = 'select';
  // 数据绑定对象
  fileModel: any = {}; 
  // 链接数据类型
  linkDataTypeOptions:any = [];
  // 提交按钮是否禁用
  clickEnable = true; 
  // 表格对象
  @ViewChild("swtable") swtable: SwGridTableComponent;   
  // 搜索数据内容
  searchDatas = {
    materialTitle: '',  // 素材名称
    materialCategory: '',  // 素材类型
  }
  // 搜索资源类型数据
  fileCategoryOptions = [
      { id: 'FILE_TYPE_ALL', text: '全部'}
  ]
  // 资源表格数据
  datas:any = [];
  // 表格是否显示加载中
  isLoading: boolean = false;
  // 表格分页组件
  pageBase: any = { orderBy: null }
  // 表格中选中的数据
  selectedDatas:any = [];
  // 选中的文件信息
  selectedFiles:any = [];
  // 封面图上传文件策略
  autoCode:string = '';
  // 上传的文件信息
  attachmentDelList = [];
  // 删除的文件信息
  attachmentAddList = [];
  // 用户角色
  userRole = '';
  constructor(
    private box: SwMassageBoxService,  //消息提示框
    private jwt: SwJwtService,
    private instanceModuleService: InstanceModuleService,
    private kmsService: KmsService,   //请求服务
  ) { }

  ngOnInit() {
    // 获取用户角色
    this.userRole = this.jwt.getToken('userRole');
    // 通过知识库标识拼接文件策略
    let kgDbInfo = JSON.parse(this.jwt.getToken('kgDbInfo'));
    let kgCode = kgDbInfo && kgDbInfo.englishCode ? kgDbInfo.englishCode : '';
    this.autoCode = kgCode ? KmsEnum.KMS_INSTANCE_IMG_RESOURCE + '_' + (kgCode.toUpperCase()) : '';

    this.fileCategoryOptions = this.fileCategoryOptions.concat(this.instanceModuleService.getResourceTypeOptions());
    this.handleSelectClick();
  }

  // tab切换
  handleTabClick(id){
    this.currentTab = id;
  }

  // enter键触发搜索
  enterSearch(event) {
    if (event.keyCode == '13') {
        this.handleSelectClick();
    }
  }

  // 查询按钮方法
  handleSelectClick() {
    this.pageBase = {
      current: 1,
      size: 10
    };
    this.getData();
  }

  //获取数据
  getData() {
    this.isLoading = true;
    const params = {
      'materialTitle': $.trim(this.searchDatas.materialTitle),
      'materialCategory': this.searchDatas.materialCategory == 'FILE_TYPE_ALL' ? '' : this.searchDatas.materialCategory,
      'current': this.pageBase.current,
      'size': this.pageBase.size
    }
    this.kmsService.queryMaterialListByParams(params).subscribe(
      data => {
        this.isLoading = false;
        if (data.code == '200') {
          this.pageBase = data.data;
          let res = data.data.records ? data.data.records : [];
          this.datas = [];
          res.forEach((item) => {
            const item1 = this.instanceModuleService.getResourceThumbnail(item,this.fileCategoryOptions);
            this.datas.push(item1);
          });
        } else {
          this.box.waring(data.msg);
        }
      }
    );
  }

  // 表格选中数据
  handleSelectData(event) {
    this.selectedDatas = event;
  }

  // 表格分页切换方法
  handlePageClick(event) {
    this.pageBase = event;
    this.getData();
  }

  // 获取文件类型名称
  getCategoryName(id){
    let items = this.fileCategoryOptions.filter(item => item.id == id);
    return items.length>0 ? items[0].text : '其他';
  }

  // 重置按钮事件方法
  handleReloadClick() {
    this.searchDatas = {
      materialTitle: '',  
      materialCategory: '', 
    }
    this.pageBase = {
      current: 1,
      size: 10
    };
    this.getData();
  }

  // 选择文件
  select(){
    this.selectedDatas.forEach(item => {
      let len = this.selectedFiles.filter(item1 => item1.materialId == item.materialId).length;
      if(len == 0){
        this.selectedFiles.push(item);
      }
    })
  }

  // 删除选中的文件
  deleteFile(i){
    let arr = JSON.parse(JSON.stringify(this.selectedFiles))
    arr.splice(i,1)
    this.selectedFiles = arr
  }

  // 保存选中项
  saveSelections(){
    let params = [];
    this.selectedFiles.forEach(el => {
      let entity = {
        associatedType: 2,
        fileInfoId: el.materialId,
        sourceId: this.param.imageMarkId
      }
      params.push(entity)
    })
    this.kmsService.saveFileRelationship(params).subscribe(
        data => {
            this.isLoading = false;
            if (data.code == '200') {
                this.box.success('保存成功！');
                this.modal.toggle();
                this.callback.emit(true);
            } else {
                this.box.waring(data.msg);
            }
        }
    );
  }

  // 上传头像成功的回调
  headImgAdd(event){
    if (event.length > 0) {
      const val = event[0].filePath + event[0].fileName;
      this.fileModel.fileThumbnail = val;
    }
  }

  // 删除头像成功的回调
  headImgDelete(event){
    this.fileModel.fileThumbnail = '';
  }

  // 保存新增的资源信息
  onSubmit({ value, valid }, event: Event) {
    if (valid) {
      value['fileThumbnail'] = this.fileModel.fileThumbnail;
      value['accessType'] = 3;
      value['approvalStatus'] = 0;
      value['currentUserRole'] = this.userRole == '知识编辑' ? 1 : 2;
      value['status'] = 0;
      value['textExtractStatus'] = 0;
      this.kmsService.batchSaveFiles([value]).subscribe(data => {
        if(data.code == '200'){
          let params = [];
          data.data.forEach(el => {
            let entity = {
              associatedType: 2,
              fileInfoId: el,
              sourceId: this.param.imageMarkId
            }
            params.push(entity)
          })
          this.kmsService.saveFileRelationship(params).subscribe(
              data => {
                  this.isLoading = false;
                  if (data.code == '200') {
                    this.box.success('保存成功!');
                    this.modal.toggle();
                    this.callback.emit(true);
                  } else {
                    this.box.waring(data.msg);
                  }
              }
          );
        }else{
          this.box.waring(data.msg);
        }
      })
    }
  }
}

